export function create_trigger(val) {
  return [
    {
      'event': 'click',
      'type': 'none',
      'link': 'http://',
      'go': '',
      'toggle': '',
      'tips': true,
      'prehide': false
    }
  ]
}
